var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 13H17V7A5 5 0 0 0 7 7v6h-.75A1.25 1.25 0 0 0 5 14.25v6.5A1.25 1.25 0 0 0 6.25 22h11.5A1.25 1.25 0 0 0 19 20.75v-6.5A1.25 1.25 0 0 0 17.75 13ZM10 7a2 2 0 0 1 4 0v6h-4Z"
})));
export default SvgLocked;